import { createParser, system } from '../core';
import { t } from '../utils';

/**
 * The parser configuration for common outline properties
 */
var config = {
  outline: true,
  outlineOffset: true,
  outlineColor: t.colors('outlineColor')
};
export var outline = system(config);
export var outlineParser = createParser(config);